<template>
  <div class="movie-editor">
    <el-form ref="form" label-width="100px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      </el-form-item>
      <el-form-item label="选择专题">
        <el-select v-model="currentItem.list" multiple clearable placeholder="请选择" style="width:400px">
          <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'movieEditor',
  data () {
    return {
      list: []
    }
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  created () {
    this.getMovies()
  },
  methods: {
    getMovies () {
      request({
        url: '/movie/topics'
      }).then(res => {
        this.list = res.data.list
      })
    }
  }
}
</script>
<style lang="less" scoped>
.movie-editor {}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/topicEditor.vue